import React, { useContext, useEffect, useState } from 'react';
import styles from './Profile.module.scss';
import Map, { ILatLng } from '../../components/map/Map';
import SearchBar from '../../components/search-bar/SearchBar';
import HeaderControls from '../../components/header-controls/HeaderControls';
import DirectoryButtonArea from '../../components/directory-button-area/DirectoryButtonArea';
import { getCurrentPosition, mapToGenericResults } from '../../lib/util';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import IGenericResult from '../../interfaces/IGenericResult';
import DirectionsPanel from '../../components/directions-panel/DirectionsPanel';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { DirectoryListType } from '../../components/directory-list/DirectoryList';
import { IAppContext } from '../../context/DefaultAppState';
import GenericButton from '../../components/generic-button/GenericButton';
import { DownloadIcon, EmailIcon, MapMarkerIcon, PrintIcon, ProfileIcon } from '../../components/icons/Icons';
import InfoSection from '../../components/info-section/InfoSection';
import ReportForm from '../../components/report-form/ReportForm';

const ProfilePage = (props: any) => {
  const appContext = useContext(AppContext);
  const { planCode, directory, recordId} = props.match.params;
  const [primaryResult, setPrimaryResult] = useState<IGenericResult | null>(null);
  const [secondaryResults, setSecondaryResults] = useState<IGenericResult[]>([]);
  const [directions, setDirections] = useState<google.maps.DirectionsResult>();
  const [formattedAddress, setFormattedAddress] = useState('');
  const [showDirectionsPanel, setShowDirectionsPanel] = useState(false);
  const [showEmailField, setShowEmailField] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [miles, setMiles] = useState('');
  const [profileIsDoctor, setProfileIsDoctor] = useState(false);
  const [showReportForm, setShowReportForm] = useState(false);

  //Get query params
  const urlLocation = props.location.search;
  const hashParams = new URLSearchParams(urlLocation);
  const fromGetDirection = hashParams.get('directions');
  const reportYearFromUrl = hashParams.get('reportYear');

  // This adjusts the height of the PDF according to how many rows there are (typically 3 per row).
  const heightModifier = secondaryResults.length ? Math.round(secondaryResults.length / 3) * 40 : 0;

  useEffect(() => {
    if (fromGetDirection === 'true') {
      setShowDirectionsPanel(true);
    }
  }, [])

  useEffect(() => {
    getProfileInformation(props, setPrimaryResult, setSecondaryResults, setMiles, setFormattedAddress, setProfileIsDoctor);
  }, [recordId])

  useEffect(() => {
    rebuildContext(planCode, directory, reportYearFromUrl, appContext);
  }, [planCode, directory, reportYearFromUrl, appContext.plansData])

  console.log(validationMessage)

  return (
    <div id="profile-container">
      <div className="header-container-mini">
        <HeaderControls />
        <div>
          <DirectoryButtonArea />
        </div>
        <div className="select-mini-bg">
          <SearchBar />
        </div>
        {appContext.isDisabled && appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code.</p>
            <p></p>
          </div>
          
        ) : null}
        {appContext.isDisabled && !appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code or leave it blank.</p>
            <p></p>
          </div>
        ) : null}
      </div>
      <div className={styles.profileContainer}>
        <div className={styles.headerContainer}>
          <h2>{primaryResult?.name}</h2>
          <div>
            <GenericButton buttonText={'Download'} handleClick={() => downloadPdf(primaryResult?.name as string, heightModifier)}>
              <DownloadIcon/>
            </GenericButton>
            <GenericButton buttonText={'Email'} handleClick={() => setShowEmailField(!showEmailField)}>
              <EmailIcon/>
            </GenericButton>
            <GenericButton buttonText={'Print'} handleClick={() => window.print()}>
              <PrintIcon/>
            </GenericButton>
          </div>
          { showDirectionsPanel ?
            <DirectionsPanel formattedAddress={formattedAddress} setShowDirectionsPanel={setShowDirectionsPanel} setValidationMessage={setValidationMessage}
                             setDirections={setDirections} getDirections={getDirections} getDistance={getDistance} setMiles={setMiles}
                             toAddress={`${primaryResult?.addressLine1}, ${primaryResult?.addressLine2 ? primaryResult?.addressLine2 + ', ' : ''}${primaryResult?.city}, ${primaryResult?.state} ${primaryResult?.zipCode}`}
                             formattedToAddress={`${primaryResult?.addressLine1} ${primaryResult?.addressLine2 ? primaryResult?.addressLine2 + ' ' : ''}${primaryResult?.city} ${primaryResult?.state} ${primaryResult?.zipCode}`.split(' ').join('+')}/>
          : null }
          {showEmailField ? (
            <div className={styles.emailFieldContainer}>
              <hr/>
              <h4>Email Result</h4>
              <p>Please Enter an Email Address</p>
              <input type="text" placeholder={'example: john.doe@example.com'} onChange={(e) => setUserEmail(e.target.value)}/>
              <button className={styles.profileButton} onClick={() => validateEmail( userEmail, setValidationMessage, () => {downloadPdf(primaryResult?.name as string, heightModifier, true, userEmail); setShowEmailField(!showEmailField)})}>Send Email</button>
            </div>
          ) : null}
          <p className={styles.error}>{validationMessage}</p>
          <hr />
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.infoSection}>
            <InfoSection key={primaryResult?.name} styles={styles} primaryResult={primaryResult} secondaryResults={secondaryResults} resultIsDoctor={profileIsDoctor}/>
            <GenericButton buttonText={'Report Incorrect Information'} handleClick={() => {setShowReportForm(!showReportForm)}}>
                    <ProfileIcon/>
            </GenericButton>
          </div>
          <div className={styles.infoSection}>
            <div className={styles.innerSection}>
              {/*Name and Address*/}
              <div className={styles.sectionHeader}>1. {primaryResult?.name}</div>
              <div className={styles.sectionBody}>
                <b>{primaryResult?.locationName == primaryResult?.name ? null : primaryResult?.locationName}</b>
                <br />
                {primaryResult?.addressLine1},
                <br/>
                {primaryResult?.addressLine2 ? <span>{primaryResult?.addressLine2 + ','}<br/></span>  : null}
                {primaryResult?.city}, {primaryResult?.state} {primaryResult?.zipCode}
              </div>
              <div className={styles.innerSection}>
                {/*Distance*/}
                <div className={styles.sectionBody}>
                  Distance: <b>{primaryResult?.approximateDistance} mi</b>
                  <br />
                  <br />
                  <GenericButton buttonText={'Get Directions'} handleClick={() => {setShowDirectionsPanel(!showDirectionsPanel);
                    getDistanceForProfile(primaryResult?.addressLine1 as string,
                      primaryResult?.addressLine2 as string,
                      primaryResult?.city as string,
                      primaryResult?.state as string,
                      primaryResult?.zipCode as string,
                      setMiles, setFormattedAddress, setDirections);}}>
                    <MapMarkerIcon/>
                  </GenericButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.mapContainer}>
          <Map currentChunk={[primaryResult, ...secondaryResults]} profileDirections={directions} planState={appContext.planState} />
        </div>
        {showReportForm ? (
            <ReportForm primaryResult={primaryResult} setShowReportForm={setShowReportForm}/>
          ) : null}
        {secondaryResults.length ?
          <div className={styles.additionalResultsContainer}>
            {secondaryResults.map((sResult, i) => (
              <div key={sResult.recordId} className={styles.additionColumn}>
                <div>{i + 2}. {sResult.name}</div>
                  <b>{sResult.locationName == sResult.name ? null : sResult.locationName}</b>
                <div className={styles.sectionBody}>{sResult?.specialty}</div>
                <span>
                  <div>{sResult?.addressLine1},</div>
                  <div>{primaryResult?.addressLine2 ? <span>{primaryResult?.addressLine2 + ','}</span>  : null}</div>
                  <div>{sResult?.city}, {sResult?.state} {sResult?.zipCode}</div>
                </span>
                <div>Phone: {sResult.phone}</div>
                <div>Fax: {sResult.fax}</div>
                <GenericButton buttonText={'Use Address'} handleClick={() => switchProfile(sResult.recordId, primaryResult as IGenericResult, setPrimaryResult, secondaryResults, setSecondaryResults, setMiles, setFormattedAddress, setDirections)}>
                  <ProfileIcon/>
                </GenericButton>
              </div>
            ))}
          </div>
          : null}
      </div>
    </div>
  );
};

const switchProfile = (
   recordId: string,
   primaryResult: IGenericResult,
   setPrimaryResult: React.Dispatch<React.SetStateAction<IGenericResult | null>>,
   secondaryResults: IGenericResult[],
   setSecondaryResults: React.Dispatch<React.SetStateAction<IGenericResult[]>>,
   setMiles: React.Dispatch<React.SetStateAction<string>>,
   setFormattedAddress: React.Dispatch<React.SetStateAction<string>>,
   setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>
   ) => {
  const newPrimary = secondaryResults.find(s => s.recordId === recordId);
  const newSecondaries: IGenericResult[] = secondaryResults.filter(s => s.recordId !== recordId);
  newSecondaries.unshift(primaryResult);
  setPrimaryResult(newPrimary as IGenericResult);
  setSecondaryResults(newSecondaries as IGenericResult[])
  setDirections(undefined);
  getDistanceForProfile(primaryResult?.addressLine1 as string,
    primaryResult?.addressLine2 as string,
    primaryResult?.city,
    primaryResult?.state,
    primaryResult?.zipCode,
    setMiles, setFormattedAddress);
}

const getProfileInformation = (props: any, setPrimaryResult: React.Dispatch<React.SetStateAction<IGenericResult | null>>, setSecondaryResults: React.Dispatch<React.SetStateAction<IGenericResult[]>>, setMiles: any, setFormattedAddress: any, setProfileIsDoctor: React.Dispatch<React.SetStateAction<boolean>>) => {
  (async () => {
    try {

      let directoryType = 0;
      switch (props.match.params.directory) {
        case DirectoryListType.doctor:
          directoryType = 1;
          break;
        case DirectoryListType.facility:
          directoryType = 2;
          break;
        case DirectoryListType.pharmacy:
          directoryType = 3;
          break;
        default:
          directoryType = 0;
          break;
      }

      // const { data } = await axios.get(`/Profile/${props.match.params.planCode}/${props.match.params.recordId}/${directoryType}`);

      const queryParams = new URLSearchParams(
        props.location.search
      );

      const reportYear =
        queryParams.get('reportYear');

      let profileUrl =
        `/Profile/${props.match.params.planCode}` +
        `/${props.match.params.recordId}` +
        `/${directoryType}`;

      if (
        directoryType === 3 &&
        reportYear
      ) {
        profileUrl +=
          `?reportYear=${reportYear}`;
      }

      console.log(
        'PROFILE REQUEST URL:',
        profileUrl
      );

      const { data } =
        await axios.get(profileUrl);

      const primaryResult: IGenericResult = mapToGenericResults([data.primaryResult])[0];
      const secondaryResults: IGenericResult[] = mapToGenericResults(data.secondaryResults);

      setPrimaryResult(primaryResult);
      setSecondaryResults(secondaryResults);
      setProfileIsDoctor(directoryType === 1 ? true : false);

      getDistanceForProfile(primaryResult?.addressLine1 as string,
        primaryResult?.addressLine2 as string,
        primaryResult?.city as string,
        primaryResult?.state as string,
        primaryResult?.zipCode as string,
        setMiles, setFormattedAddress);
    } catch (err) {
      console.error(err);
    }
  })();
};

// TODO: Duplicated From Profile Card. Centralize Functions.

const getDistanceForProfile = (
  address1: string,
  address2: string,
  city: string,
  state: string,
  zipCode: string,
  setMiles: React.Dispatch<React.SetStateAction<string>>,
  setFormattedAddress: React.Dispatch<React.SetStateAction<string>>,
  setDirections?: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>
) => {
  (async () => {
    try {
      let currentLocation = { lat: 0, lng: 0 };
      const res: any = await getCurrentPosition();
      const { latitude, longitude } = res.coords;
      currentLocation.lat = latitude;
      currentLocation.lng = longitude;
      let distance: string = 'N/A';
      if (process.env.REACT_APP_MAPS_API_KEY) {
        const formattedAddress = `${address1} ${address2 ? address2 + ' ' : ''}${city} ${state} ${zipCode}`.split(' ').join('+');
        setFormattedAddress(formattedAddress);
        const geocode = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
        const locationToMark: { lat: number; lng: number } = geocode.data.results[0].geometry.location;
        if(setDirections) {
          getDirections(currentLocation, locationToMark, setDirections);
        }
        distance = getDistance(currentLocation, locationToMark);
      }
      setMiles(distance);
    } catch (err) {
      console.error(err);
    }
  })();
};

  const rad = (x: number) => {
    return (x * Math.PI) / 180;
  };

  const getMiles = (meters: number) => {
    return (meters * 0.000621371192).toFixed(2);
  };

  const getDistance = (p1: ILatLng, p2: ILatLng): string => {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = rad(p2.lat - p1.lat);
    var dLong = rad(p2.lng - p1.lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return getMiles(d); // returns the distance in meter
  };

  const getDirections = (origin: any, destination: any, setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>) => {
    const DirectionsService = new google.maps.DirectionsService();

    DirectionsService.route(
      {
        origin: new google.maps.LatLng(origin.lat, origin.lng),
        destination: new google.maps.LatLng(destination.lat, destination.lng),
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          setDirections(result);
        } else {
          console.error(`error fetching directions ${result}`);
          return {
            geocoded_waypoints: [],
            routes: []
          };
        }
      }
    );
  };

  const validateEmail = (email: string, setValidationMessage: any, callback: () => void) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isValid = regex.test(email);

    if(isValid) {
      setValidationMessage('');
      callback();
    } else {
      setValidationMessage('Email is not valid. Please check that the email address entered is formatted correctly.')
    }
  }

const downloadPdf = (pdfName: string, heightModifier: number, packageForEmail?: boolean, email?: string) => {
  const input = document.getElementById('profile-container');
  html2canvas(input as HTMLElement)
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');
      const height = 500 + heightModifier;
      console.log(height);
      pdf.addImage(imgData, 'PNG', 0, 0, 600, height);
      // pdf.output('dataurlnewwindow');
      if(!packageForEmail) {
        pdf.save(`${pdfName}.pdf`);
      } else {
        axios.post(`/SendEmail`, {
          planTitle: window.location.host.split('.')[0],
          planBase: window.location.host === 'localhost:3000' ? 'alignseniorcare.com' : window.location.host,
          fileAttachment: btoa(pdf.output()),
          fileName: pdfName,
          userEmail: email
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.error(err);
        })
      }
    });
}

const rebuildContext = (planCode: string | null, directory: string | null, reportYear: string | null, appContext: IAppContext) => {
  if (planCode) {
    const currentPlan = appContext.plansData.find(p => p.contractId === planCode);

    if(currentPlan) {
      appContext.updatePlanCode(planCode);
      appContext.updatePlan(currentPlan);
      appContext.updatePlanName(currentPlan.planName);
      appContext.updateDisclaimerUrl(currentPlan.ipdDisclaimerLink);
      appContext.updatePlanState(currentPlan.state);
    }
  }

  if (directory) {
    switch (directory) {
      case DirectoryListType.doctor:
        appContext.updateListType(DirectoryListType.doctor);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.facility:
        appContext.updateListType(DirectoryListType.facility);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.pharmacy:
        appContext.updateListType(DirectoryListType.pharmacy);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.all:
        appContext.updateListType(DirectoryListType.all);
        appContext.updateSelected(true);
        break;
      default:
        appContext.updateListType(DirectoryListType.none);
        appContext.updateSelected(false);
        break;
    }
  }

  // Restore Report Year for Pharmacy
if (
  directory === DirectoryListType.pharmacy &&
  reportYear
) {
  const parsedReportYear = parseInt(reportYear);

  if (
    parsedReportYear === 2026 ||
    parsedReportYear === 2027
  ) {
    appContext.updateReportYear(parsedReportYear);
  }
}

};


export default ProfilePage;
